export const CASE_MANAGER = 'caseManager';
export const DATES = 'dates';
export const DISCHARGE_REASON = 'reason';
export const END_DATE = 'endDate';
export const EPISODE_CLASSIFICATION = 'episodeClassification';
export const GROUP_ID = 'groupId';
export const HEALTH_PLAN_CLASSIFICATION = 'healthPlanClassification';
export const HOSPITAL = 'hospital';
export const LATEST_REHAB_STATE = 'latestRehabState';
export const LOCATION = 'location';
export const LOCATION_TYPE = 'locationType';
export const NONE = 'None';
export const NONE_OPTION = { id: 'null', name: NONE };
export const PAYER = 'payer';
export const PLAN_TYPE_CLASSIFICATION = 'planTypeClassification';
export const PREDECESSOR_GROUP = 'predecessorGroup';
export const PHYSICIAN_GROUP = 'physicianGroup';
export const PHYSICIAN_TEAM = 'physicianTeam';
export const SENDING_GROUP = 'sendingGroup';
export const START_DATE = 'startDate';
export const TRANSFERRED_FROM_CLIENT = 'transferredFromClient';
export const REFERRED_BY_ID = 'referredById';
export const UTILIZATION_MANAGER = 'utilizationManager';
export const OWNER_CLIENT = 'ownerClient';
export const OWNER = 'owner';
export const ONLY_OTHER_ORGANIZATIONS = 'onlyOtherOrganizations';
export const STATUS_OUT_OF_DATE = 'statusOutOfDate';
export const REMOVED_FROM_CENSUS = 'removedFromCensus';

export enum PatientState {
  CURRENT = 'current',
  CONTINUED = 'continued',
  LATEST = 'latest',
}

export const filterKeysToWords: Record<string, string> = {
  [HEALTH_PLAN_CLASSIFICATION]: 'Plan',
  [PLAN_TYPE_CLASSIFICATION]: 'Plan Type',
  [EPISODE_CLASSIFICATION]: 'Episode Type',
  [CASE_MANAGER]: 'Case Manager',
  [UTILIZATION_MANAGER]: 'Utilization Manager',
};
